"use client";
import * as React from "react";
import { IPage } from "@/types/page";
import clsx from "clsx";
import { TableOfContents, X } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
export const CorporatePageFooterNav = ({
  pages,
  currentPageId,
}: {
  pages: IPage[];
  currentPageId: string;
}) => {
  return (
    <div className={clsx("space-y-6")}>
      <p className="font-semibold text-xl">
        L&apos;établissement Grand Paris Aménagement
      </p>
      <div className="flex">
        <div className="h-1 w-10 bg-brand-red" />
      </div>
      <div className="grid _xl:grid-cols-2 gap-4 grid-rows-5 grid-flow-col">
        {pages
          .filter((page: IPage) => !page.hidePageFromCorporateNav)
          .map((page: IPage) => (
            <a
              key={page.sys.id}
              href={`/etablissement/${page.slug}`}
              className={clsx(
                "block hover:text-brand-blue hover:underline",
                currentPageId === page.sys.id
                  ? "font-bold text-brand-red pointer-events-none"
                  : "font-normal"
              )}
            >
              {page.title}
            </a>
          ))}
      </div>
    </div>
  );
};

export const CorporateFloatingNav = ({
  pages,
  currentPageId,
}: {
  pages: IPage[];
  currentPageId: string;
}) => {
  const corporateNavWrapper = React.useRef<HTMLDivElement>(null);
  const [visible, setVisible] = React.useState<boolean>(false);
  //   React.useEffect(() => {
  //     gsap.from(corporateNavWrapper, {
  //       duration: 0.35,
  //       ease: "power1.inOut",
  //       opacity: 0,
  //       x: -10,
  //     });
  //   }, [visible]);

  useGSAP(() => {
    // gsap code here...
    if (visible) {
      gsap.to(corporateNavWrapper.current, {
        duration: 0.15,
        ease: "power1.inOut",
        opacity: 1,
        x: 0,
      });
    } else {
      gsap.to(corporateNavWrapper.current, {
        duration: 0.15,
        ease: "power1.inOut",
        opacity: 0,
        x: -10,
      });
    }
  }, [visible]);
  return (
    <>
      <button
        onClick={() => setVisible(!visible)}
        className="text-brand-red border bg-white/90 rounded-full p-2 shadow-md relative z-40 hover:bg-brand-red hover:border-white hover:text-white"
      >
        {!visible ? (
          <TableOfContents className="w-4 h-4" />
        ) : (
          <X className="w-4 h-4" />
        )}
      </button>
      <div
        ref={corporateNavWrapper}
        className={clsx(
          "opacity-0 absolute z-30 -right-2 -top-2 space-y-6 bg-white rounded-sm p-4 w-[300px] pr-12 shadow-lg",
          !visible ? "pointer-events-none" : "pointer-events-auto"
        )}
      >
        <div className="space-y-3">
          {pages
            .filter((page: IPage) => !page.hidePageFromCorporateNav)
            .map((page: IPage) => (
              <a
                key={page.sys.id}
                href={`/etablissement/${page.slug}`}
                className={clsx(
                  "block hover:underline hover:text-gray-600 text-brand-blue text-sm",
                  currentPageId === page.sys.id
                    ? "font-bold text-brand-red pointer-events-none"
                    : "font-normal"
                )}
              >
                {page.title}
              </a>
            ))}
        </div>
      </div>
    </>
  );
};

export const CorporateFloatingButtonNav = ({
  pages,
  currentPageId,
}: {
  pages: IPage[];
  currentPageId: string;
}) => {
  const corporateNavWrapper = React.useRef<HTMLDivElement>(null);
  const [visible, setVisible] = React.useState<boolean>(false);
  //   React.useEffect(() => {
  //     gsap.from(corporateNavWrapper, {
  //       duration: 0.35,
  //       ease: "power1.inOut",
  //       opacity: 0,
  //       x: -10,
  //     });
  //   }, [visible]);

  useGSAP(() => {
    // gsap code here...
    if (visible) {
      gsap.to(corporateNavWrapper.current, {
        duration: 0.15,
        ease: "power1.inOut",
        opacity: 1,
        x: 0,
      });
    } else {
      gsap.to(corporateNavWrapper.current, {
        duration: 0.15,
        ease: "power1.inOut",
        opacity: 0,
        x: -10,
      });
    }
  }, [visible]);
  return (
    <>
      <button
        onClick={() => setVisible(!visible)}
        className="text-white bg-brand-blue flex justify-center items-center gap-x-2  rounded-sm p-2 shadow-md relative z-40 hover:bg-white hover:text-brand-blue hover:border-white text-sm px-3 py-1"
      >
        {!visible ? (
          <>
            <TableOfContents className="w-4 h-4" /> Menu
          </>
        ) : (
          <>
            <X className="w-4 h-4" />
            Fermer
          </>
        )}
      </button>
      <div
        ref={corporateNavWrapper}
        className={clsx(
          "pt-12 opacity-0 absolute z-30 -left-2 -top-2 space-y-6 bg-white rounded-sm p-4 w-[300px] pr-12 shadow-lg",
          !visible ? "pointer-events-none" : "pointer-events-auto"
        )}
      >
        <div className="space-y-3">
          {pages
            .filter((page: IPage) => !page.hidePageFromCorporateNav)
            .map((page: IPage) => (
              <a
                key={page.sys.id}
                href={`/etablissement/${page.slug}`}
                className={clsx(
                  "block hover:underline hover:text-gray-600 text-brand-blue text-sm",
                  currentPageId === page.sys.id
                    ? "font-bold text-brand-red pointer-events-none"
                    : "font-normal"
                )}
              >
                {page.title}
              </a>
            ))}
        </div>
      </div>
    </>
  );
};
